import React, { useState, useEffect, Children, useRef, useLayoutEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

import "./css/Stepper.css";
import { consumirApi } from "../api/ph";
export default function Stepper({
  children,
  initialStep = 1,
  onStepChange = () => { },
  onFinalStepCompleted = () => { },
  stepCircleContainerClassName = "",
  stepContainerClassName = "",
  contentClassName = "",
  footerClassName = "",
  backButtonProps = {},
  nextButtonProps = {},
  backButtonText = "Regresar",
  nextButtonText = "Siguiente",
  disableStepIndicators = true,
  renderStepIndicator,
  nextButtonDisabled = false, setMostrarNuevoPrestamo,numero,
  leftAction,
  nextButtonHint,
  ...rest
}) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [direction, setDirection] = useState(0);

  const indicatorsRowRef = useRef(null);

  useEffect(() => {
    if (indicatorsRowRef.current) {
      const activeElement = indicatorsRowRef.current.querySelector(
        `[data-step="${currentStep}"]`
      );
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  }, [currentStep]);
  const stepsArray = Children.toArray(children);
  const totalSteps = stepsArray.length;
  const isCompleted = currentStep > totalSteps;
  const isLastStep = currentStep === totalSteps;
  
  const updateStep = (newStep) => {
    setCurrentStep(newStep);
    if (newStep > totalSteps) {
      onFinalStepCompleted();
    } else {
      onStepChange(newStep);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setDirection(-1);
      updateStep(currentStep - 1);
    }
  };

  const handleNext = () => {
    if (!isLastStep) {
      setDirection(1);
      updateStep(currentStep + 1);
    }
  };
 
  const handleComplete = async () => {
    setDirection(1);
    try {
      const response = await consumirApi({
        url: `${apiUrl}/cambiaEstatusPreregistro/${numero}`,
        method: 'GET',
      });

      if (!response.success) {
        console.error("❌ Error al llamar la API:", response.message);
      }
    } catch (error) {
      console.error("❌ Error inesperado:", error);
    } finally {
      updateStep(totalSteps + 1);
    }
  };



  return (
    <div
      className={`step-circle-container ${stepCircleContainerClassName}`}
      style={{ border: "1px solid #222" }}
    >
      <div ref={indicatorsRowRef} className={`step-indicator-row ${stepContainerClassName}`}>
        {stepsArray.map((_, index) => {
          const stepNumber = index + 1;
          const isNotLastStep = index < totalSteps - 1;
          return (
            <React.Fragment key={stepNumber}>
              {renderStepIndicator ? (
                renderStepIndicator({
                  step: stepNumber,
                  currentStep,
                  onStepClick: (clicked) => {
                    if (disableStepIndicators) return;
                    setDirection(clicked > currentStep ? 1 : -1);
                    updateStep(clicked);
                  },
                })
              ) : (
                <StepIndicator
                  step={stepNumber}
                  disableStepIndicators={disableStepIndicators}
                  currentStep={currentStep}
                  onClickStep={(clicked) => {
                    setDirection(clicked > currentStep ? 1 : -1);
                    updateStep(clicked);
                  }}
                />
              )}
              {isNotLastStep && (
                <StepConnector isComplete={currentStep > stepNumber} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <StepContentWrapper
        isCompleted={isCompleted}
        currentStep={currentStep}
        direction={direction}
        className={`step-content-default ${contentClassName}`}
      >
        {stepsArray[currentStep - 1]}
      </StepContentWrapper>

      {!isCompleted && (
        <div className={`footer-container ${footerClassName}`}>
          <div className={`footer-nav ${currentStep !== 1 ? "end" : "end"}`}>
            {/* Si quieres mostrar botón Regresar, descomenta este bloque */}
            {/* {currentStep !== 1 && (
              <button
                onClick={handleBack}
                className={`back-button ${currentStep === 1 ? "inactive" : ""}`}
                {...backButtonProps}
              >
                {backButtonText}
              </button>
            )} */}
            {leftAction}
            <div className="flex items-center gap-3 ml-auto">
              {nextButtonHint && (
                <span className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-bold text-emerald-600 bg-white border border-emerald-300 rounded-xl uppercase tracking-wider">
                  <svg xmlns="http://www.w3.org/2000/svg" className="size-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                  {nextButtonHint}
                </span>
              )}
              <button
                onClick={() => {
                  if (isLastStep) {
                    handleComplete();
                    setMostrarNuevoPrestamo(false);
                  } else {
                    handleNext();
                  }
                }}
                data-tour="stepper-siguiente-btn"
                className={`next-button ${nextButtonDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={nextButtonDisabled}
                {...nextButtonProps}
              >
                {isLastStep ? "Finalizar" : nextButtonText}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function StepContentWrapper({ isCompleted, currentStep, direction, children, className }) {
  const [parentHeight, setParentHeight] = useState(0);

  return (
    <motion.div
      className={className}
      style={{ position: "relative", overflow: "hidden" }}
      animate={{ height: isCompleted ? 0 : parentHeight }}
      transition={{ type: "spring", duration: 0.4 }}
    >
      <AnimatePresence initial={false} mode="sync" custom={direction}>
        {!isCompleted && (
          <SlideTransition
            key={currentStep}
            direction={direction}
            onHeightReady={(h) => setParentHeight(h)}
          >
            {children}
          </SlideTransition>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

function SlideTransition({ children, direction, onHeightReady }) {
  const containerRef = useRef(null);

  useLayoutEffect(() => {
    if (containerRef.current) onHeightReady(containerRef.current.offsetHeight);
  }, [children, onHeightReady]);

  return (
    <motion.div
      ref={containerRef}
      custom={direction}
      variants={stepVariants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{ duration: 0.4 }}
      style={{ position: "absolute", left: 0, right: 0, top: 0 }}
    >
      {children}
    </motion.div>
  );
}

const stepVariants = {
  enter: (dir) => ({
    x: dir >= 0 ? "-100%" : "100%",
    opacity: 0,
  }),
  center: {
    x: "0%",
    opacity: 1,
  },
  exit: (dir) => ({
    x: dir >= 0 ? "50%" : "-50%",
    opacity: 0,
  }),
};

export function Step({ children }) {
  return <div className="step-default">{children}</div>;
}

function StepIndicator({ step, currentStep, onClickStep, disableStepIndicators }) {
  const status =
    currentStep === step ? "active" : currentStep < step ? "inactive" : "complete";

  const handleClick = () => {
    if (step !== currentStep && !disableStepIndicators) onClickStep(step);
  };

  return (
    <motion.div
      className="step-indicator"
      animate={status}
      initial={false}
      data-step={step}
      onClick={disableStepIndicators ? undefined : handleClick}
      style={{ cursor: disableStepIndicators ? "default" : "pointer" }}
    >
      <motion.div
        variants={{
          inactive: { scale: 1, backgroundColor: "#222", color: "#a3a3a3" },
          active: { scale: 1, backgroundColor: "#5227FF", color: "#5227FF" },
          complete: { scale: 1, backgroundColor: "#5227FF", color: "#3b82f6" },
        }}
        transition={{ duration: 0.3 }}
        className="step-indicator-inner"
        style={{ cursor: disableStepIndicators ? "default" : "pointer" }}
      >
        {status === "complete" ? (
          <CheckIcon className="check-icon" />
        ) : status === "active" ? (
          <div className="active-dot" />
        ) : (
          <span className="step-number">{step}</span>
        )}
      </motion.div>
    </motion.div>
  );
}

function StepConnector({ isComplete }) {
  const lineVariants = {
    incomplete: { width: 0, backgroundColor: "transparent" },
    complete: { width: "100%", backgroundColor: "#5227FF" },
  };

  return (
    <div className="step-connector">
      <motion.div
        className="step-connector-inner"
        variants={lineVariants}
        initial={false}
        animate={isComplete ? "complete" : "incomplete"}
        transition={{ duration: 0.4 }}
      />
    </div>
  );
}

function CheckIcon(props) {
  return (
    <svg {...props} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
      <motion.path
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ delay: 0.1, type: "tween", ease: "easeOut", duration: 0.3 }}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 13l4 4L19 7"
      />
    </svg>
  );
}
